export const SaveCheckpointControl = {
  flow: 'x',
  position: 'relative',
  width: '100px',
  height: '30px',
  fontSize: 'X',
  align: 'center',
  pointerEvents: 'auto',
  onInit: (el, s) => {
    // The checkpoint bus is an ENHANCEMENT, not a precondition — see the
    // identical guard in ConnectionNavbar.js. Without an SDK the control
    // still mounts and the commit button still renders; only the AUTO-save
    // status message is missing.
    if (!el.sdk?.rootBus?.on) return
    const handler = ({ origin }) => {
      if (origin === 'auto') {
        s.status = 'autoSaved'
        setTimeout(
          () =>
            s.update({
              status: null
            }),
          1500
        )
      }
    }
    el.sdk.rootBus.on('checkpoint:done', handler)
  },
  state: {
    status: null
  },
  CommitBtn: {
    extends: 'Button',
    hide: true,
    show: (el, st) => st.status === null,
    icon: 'cloud',
    text: '{{ editor.checkpoint.commit | polyglot }}',
    width: '100%',
    onClick: async (ev, el, st) => {
      try {
        st.update({
          status: 'saving'
        })
        await el.sdk.checkpoint()
        st.update({
          status: 'manualSaved'
        })
        setTimeout(
          () =>
            st.update({
              status: null
            }),
          2500
        )
      } catch (err) {
        console.error(err)
        st.update({
          status: null
        })
      }
    }
  },
  ManualSavedStatusMessage: {
    if: (el, st) => st.status === 'manualSaved',
    tag: 'Span',
    text: '{{ editor.checkpoint.saved | polyglot }}',
    color: 'green',
    textAlign: 'center',
    width: '100%'
  },
  AutoSavedStatusMessage: {
    if: (el, st) => st.status === 'autoSaved',
    tag: 'Span',
    text: '{{ publish.tools.autosaved | polyglot }}',
    color: 'green',
    textAlign: 'center',
    width: '100%'
  },
  SavingStatusMessage: {
    if: (el, st) => st.status === 'saving',
    tag: 'Span',
    text: '{{ common.state.saving | polyglot }}',
    color: 'inactive',
    textAlign: 'center',
    width: '100%'
  }
}
